import React, { useState } from 'react';

import { Menu, SemanticICONS } from "semantic-ui-react";
import _                       from "underscore";

import { Align, SemanticUIColor, Size, }          from '@src/types';
import { BasicDialog }                            from '@src/views/components/modals/BasicDialog';
import { BasicDialogContainer }                   from '@src/views/components/modals/BasicDialogContainer';
import { MenuItemWithIconAndIndicator }           from "@src/views/components/menus/MenuItemWithIconAndIndicator";
import { MenuizedFocusContainerLayout }           from "@src/views/containers/MenuizedFocusContainerLayout";
import { ENTITY_ICONS }                           from "@src/constants";
import { UseIf }                                  from "@src/views/components/display/EqualValues";
import { GlobalProjectVisibilitySettingsControl } from "@src/views/pages/projects/operations/GlobalProjectVisibilitySettingsControl";


export type SettingViewConfig = {
    menuLabel: string,
    menuIcon: SemanticICONS,
    onMenuClick: () => void,
    hasOptions: boolean,
    minOptionWidth: string,
    maxOptionWidth: string,
}

interface GlobalSettingsDialogProps {}

const GlobalSettingsDialogDefaultProps = {} satisfies Partial<GlobalSettingsDialogProps>

enum SETTING_VIEWS {
    PROJECT_VISIBILITY
}

function GlobalSettingsDialog( _props: GlobalSettingsDialogProps ){

    const props = { ...GlobalSettingsDialogDefaultProps, ..._props };

    const [ settingView, setSettingView ] = useState<SETTING_VIEWS>( SETTING_VIEWS.PROJECT_VISIBILITY );

    const settingConfigs: Record<SETTING_VIEWS, SettingViewConfig> = {

        [ SETTING_VIEWS.PROJECT_VISIBILITY ]: {
            menuLabel:      'Project Visibility',
            menuIcon:       ENTITY_ICONS.PROJECTS.ENTITY,
            onMenuClick:    () => {
                setSettingView( SETTING_VIEWS.PROJECT_VISIBILITY );
            },
            hasOptions:     false,
            minOptionWidth: '150px',
            maxOptionWidth: 'auto'
        },
    };

    return (
        <BasicDialog
            showSubmitButton={ false }
            controlAlign={ Align.CENTER }
            className={ 'no-padding' }
            cancelLabel={ 'Close' }>

            <BasicDialogContainer title={ 'Global Settings' } titleColor={ SemanticUIColor.PURPLE } contentPadding={ Size.MD }>

                <MenuizedFocusContainerLayout
                    minContainerHeight={ '400px' }
                    menuContent={ (

                        <Menu fluid vertical size={ 'small' }>

                            { _.pairs( settingConfigs ).map( ( [ type, config ] ) => (

                                <MenuItemWithIconAndIndicator
                                    key={ type }
                                    menuIcon={ config.menuIcon }
                                    onClick={ config.onMenuClick }
                                    withIndicator={ false }
                                    isActive={ settingView === SETTING_VIEWS.PROJECT_VISIBILITY }>

                                    { config.menuLabel }

                                </MenuItemWithIconAndIndicator>

                            ) ) }

                        </Menu>

                    ) }
                    viewContent={ (

                        <>
                            <UseIf x={ settingView } eq={ SETTING_VIEWS.PROJECT_VISIBILITY }>

                                <GlobalProjectVisibilitySettingsControl/>

                            </UseIf>
                        </>

                    ) }
                    optionsContent={ !settingConfigs[ settingView ].hasOptions ? null : (
                        <>

                        </>
                    ) }
                />

            </BasicDialogContainer>

        </BasicDialog>
    );
}

export {
    GlobalSettingsDialog,
    GlobalSettingsDialogDefaultProps,
    type GlobalSettingsDialogProps,
};
